import React, { useEffect, useState } from "react";
import "./KnowledgeBase.scss";
import { IForm } from "../../shared/widgets/Form/models/Form.model";
import { KnowledgeBaseForm } from "./KnowledgeBaseForm";
import { IKB } from "../../../models/kb.model";
import SharedForm from "../../shared/widgets/Form/Form";
import { Button } from "primereact/button";
import { FakeKnowledgeBase } from "../../../fakeStorage/kb/KnowledgeBase";
import { APIService } from "../../../services/APIService";
import { ServiceURI } from "../../../services/ServiceURI";
import CardLayout from "../../shared/pageLayouts/cardLayout/CardLayout";
import CreateLayout from "../../shared/pageLayouts/createLayout/CreateLayout";
import Card from "../../shared/widgets/Card/Card";
import { FaFilter } from "react-icons/fa";

export default function KnowledgeBase() {
  const [knowledgeBases, setKnowledgeBase] = useState<IKB[]>(FakeKnowledgeBase);
  const [isCreateTab, setIsCreateTab] = useState(false);
  const [form, setForm] = useState<IForm[]>(KnowledgeBaseForm);
  const [isEditMode, setIsEditMode] = useState(false);

  const fetchTools = async () => {
    const res = await APIService.getCall(
      ServiceURI.KNOWLEDGE_BASE.FATCH_KNOWLEDGE_BASE
    );
    if (res) {
      setKnowledgeBase(res);
    }
  };

  useEffect(() => {
    fetchTools();
  }, []);

  const handleCardClick = (index: number) => {
    const selectedCard: any =
      knowledgeBases.find((_, i) => i === index) || null;
    if (selectedCard) {
      const updateForm = KnowledgeBaseForm.map((item) => {
        return { ...item, value: selectedCard[item.field] };
      });
      setIsEditMode(true);
      setForm(updateForm);
      setIsCreateTab(true);
    }
  };

  return (
    <div className="tools-layout">
      {isCreateTab ? (
        <CreateLayout
          title="Knowledge Base"
          contentChildren={KbContent(setIsCreateTab, form, setForm, isEditMode)}
          goBack={() => setIsCreateTab(false)}
        />
      ) : (
        <CardLayout
          title="Knowledge Base"
          addButtonClicked={() => {
            setIsEditMode(false);
            setForm(KnowledgeBaseForm);
            setIsCreateTab(true);
          }}
        >
          {knowledgeBases.map((item, i) => {
            return (
              <Card
                key={i}
                icon={<FaFilter />}
                item={{
                  title: item.name,
                  content: item.description,
                  logo: item.logo,
                }}
                handleCardClick={() => handleCardClick(i)}
              />
            );
          })}
        </CardLayout>
      )}
    </div>
  );
}

const KbContent = (
  setIsCreateTab: any,
  form: IForm[],
  setForm: any,
  isEditMode: boolean
) => {
  const formRender = (
    <div className="create-form-content">
      <SharedForm form={form} setForm={setForm} />
    </div>
  );

  const footerRender = (
    <div className="create-form-footer">
      <Button
        label="Cancel"
        onClick={() => setIsCreateTab(false)}
        severity="secondary"
        text
      />
      <Button
        label={`${isEditMode ? "Update" : "Create"} Knowledge Base`}
        onClick={() => setIsCreateTab()}
        raised
        className="primary"
      />
    </div>
  );

  return (
    <>
      {formRender}
      {footerRender}
    </>
  );
};
